/**
 * @fileoverview POST handler for the "/apps/user_info/merge_users" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import { appsUserInfoMergeUsersCacheKeys } from "./constants";
import type { PostAppsUserInfoMergeUsersProps, AppsUserInfoMergeUsersResult } from "./types";

export const postAppsUserInfoMergeUsers = reactQueryMutationAdapter(
  appsUserInfoMergeUsersCacheKeys,
  (props: PostAppsUserInfoMergeUsersProps): Promise<AppsUserInfoMergeUsersResult> => {
    return fetch("/apps/user_info/merge_users", "POST", props, {}, { propagateFetchRequestError: false });
  }
);
